"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputDatepicker = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var input_field_1 = require("../input-field/input-field");
var styles_1 = require("./styles");
var InputDatepicker = function (_a) {
    var error = _a.error, prazoEntrega = _a.prazoEntrega, errorMessage = _a.errorMessage, inputProps = _a.inputProps, required = _a.required, isTouched = _a.isTouched, min = _a.min, quandoModificarPrazoEntrega = _a.quandoModificarPrazoEntrega;
    var prazoEntregaAtual = prazoEntrega;
    var prazoEntregaPadrao = new Date(new Date().setHours(0, 0, 0));
    // setando os valores default para o estado do form e para a função de submit
    var _b = (0, react_1.useState)(prazoEntregaAtual || prazoEntregaPadrao), startDate = _b[0], setStartDate = _b[1];
    (0, react_1.useEffect)(function () {
        quandoModificarPrazoEntrega(startDate);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate]);
    return (react_1.default.createElement(styles_1.DatepickercontainerStyled, null,
        react_1.default.createElement(react_datepicker_1.default, { className: error ? 'error' : '', selected: startDate, locale: "pt-BR", format: true, popperPlacement: "top", minDate: new Date(), maxDate: (0, date_fns_1.addYears)(new Date(), 5), dateFormat: "P", onChange: function (date) {
                setStartDate(date);
            } }),
        react_1.default.createElement(input_field_1.InputField, { type: "text", inputProps: __assign(__assign({}, inputProps), { min: min }), value: (startDate === null || startDate === void 0 ? void 0 : startDate.toString()) || '', isTouched: isTouched, required: required, hasError: error, errorMsg: errorMessage, onChange: function () {
                quandoModificarPrazoEntrega(startDate);
            } })));
};
exports.InputDatepicker = InputDatepicker;
